import {BulkAssemblyTabStateAttributes} from 'molbio/bulk-assembly/backbone/BulkAssemblyBackboneConstants';
import {BulkAssemblyModel} from 'molbio/bulk-assembly/backbone/BulkAssemblyFileState';
import {PREFERENCE_KEY_IGNORE, TabState, TabStateDefaults} from 'Navigation';

interface BulkAssemblyOverviewTabState {
  get<K extends keyof BulkAssemblyTabStateAttributes>(key: K): BulkAssemblyTabStateAttributes[K];
  set<K extends keyof BulkAssemblyTabStateAttributes>(
    attributeName: K,
    value: BulkAssemblyTabStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): BulkAssemblyOverviewTabState;
  set(obj: Partial<BulkAssemblyTabStateAttributes>): BulkAssemblyOverviewTabState;
}

class BulkAssemblyOverviewTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Overview',
      closeable: false,
      preferenceKey: PREFERENCE_KEY_IGNORE,
    };
  }

  bulkAssemblyModel(): BulkAssemblyModel {
    return this.get('bulkAssembly');
  }
}

export default BulkAssemblyOverviewTabState;
